module.exports = __webpack_public_path__ + "img/39.e836f0ec.jpg";